import { createContext } from 'react'

export type CollapseContextProps = {
  id: string
  open: boolean
}

export const CollapseContext = createContext<CollapseContextProps>({} as CollapseContextProps)
